import { render, staticRenderFns } from "./loanCard.vue?vue&type=template&id=217a1b92&scoped=true"
import script from "./loanCard.vue?vue&type=script&lang=js"
export * from "./loanCard.vue?vue&type=script&lang=js"
import style0 from "./loanCard.vue?vue&type=style&index=0&id=217a1b92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217a1b92",
  null
  
)

export default component.exports